import React from 'react';
import { debounce } from 'debounce';
import SearchIcon from '../Assets/Icons/SearchIcon';

function SearchInput({ placeHolder, searchText, width, inputHeight, changeFunction, marginTop }) {
  return (
    <div className={`searchInput ${width ? width : 'w-full'}`}>
      {searchText ? <h4 className="font-semibold text-sm">Search</h4> : null}
      <label className={`flex justify-between items-center  rounded-xl border-[1px] border-[#dde4de] w-full px-6 ${marginTop ? marginTop : 'mt-4'}` }>
        <input
          onChange={debounce(changeFunction, 500)}
          className={`w-[90%] outline-0  text-sm ${inputHeight ? inputHeight : 'h-[56px]'}`}
          placeholder={placeHolder}
        />
        <SearchIcon />
      </label>
    </div>
  );
}

export default SearchInput;
